const EMPTY = '—';

export function fmtNum(value, digits = 0) {
  if (value === null || value === undefined || value !== value) return EMPTY;
  const num = Number(value);
  if (!Number.isFinite(num)) return EMPTY;
  return num.toLocaleString('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function fmtMoney(value) {
  if (value === null || value === undefined || value !== value) return EMPTY;
  const num = Number(value);
  if (!Number.isFinite(num)) return EMPTY;
  return `${Math.round(num).toLocaleString('ru-RU')} ₽`;
}

export function fmtPct(value) {
  if (value === null || value === undefined || value !== value) return EMPTY;
  const num = Number(value);
  if (!Number.isFinite(num)) return EMPTY;
  return `${num.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
}

export function fmtHours(seconds) {
  if (seconds === null || seconds === undefined || seconds !== seconds) return EMPTY;
  const total = Math.round(Number(seconds) / 60);
  if (!Number.isFinite(total)) return EMPTY;
  if (total < 1) return '<1 мин';
  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const minutes = total % 60;
  if (days > 0) return `${days} д ${hours} ч`;
  if (hours > 0) return `${hours} ч ${minutes} м`;
  return `${minutes} м`;
}

// Часы числом («13,5») из секунд — для колонок «..., ч.»
export function fmtHoursNum(seconds) {
  if (seconds === null || seconds === undefined || seconds !== seconds) return EMPTY;
  const hours = Number(seconds) / 3600;
  if (!Number.isFinite(hours)) return EMPTY;
  return hours.toLocaleString('ru-RU', { maximumFractionDigits: 1 });
}

export function fmtDate(value) {
  if (!value) return EMPTY;
  let normalized = value;
  if (typeof normalized === 'number' || /^\d+$/.test(normalized)) {
    const epoch = Number(normalized);
    // pandas to_json: datetime64[ns] → epoch ms, datetime64[us] (duckdb) → epoch seconds
    normalized = epoch > 1e11 ? epoch : epoch * 1000;
  }
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return EMPTY;
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
}

export function toIsoDate(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
